import './Lite.scss';
import React, { FC } from 'react';
import SafeLink from '@/components/extra/SafeLink/SafeLink';
import type {
    Zone as ZoneFields,
    Matrix as MatrixFields,
} from '@/generated/graphql';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';
import Photo from '@/components/media/Photo/Photo';

type LiteProps = {
    fields: ZoneFields | MatrixFields;
    path: string;
};

const Lite: FC<LiteProps> = ({ fields, path }) => {
    return (
        <article className="Lite">
            <h2 className="Lite_title">
                {fields.title}

                <SafeLink to={path} className="Lite_link">
                    <ButtonIcon
                        className="Lite_linkIcon"
                        icon="chevron"
                        size="l"
                    />
                </SafeLink>
            </h2>
            <Photo fields={fields.bannerPhoto[0]} className="Lite_banner" />
            <p className="Lite_banner">{fields.bannerText}</p>
        </article>
    );
};

export default Lite;
